"use strict";
exports.__esModule = true;
exports.DefaultEntityFields = exports.FieldType = void 0;
var FieldType;
(function (FieldType) {
    FieldType["SINGLE_LINE_TEXT"] = "single_line_text";
    FieldType["MULTI_LINE_TEXT"] = "multi_line_text";
    FieldType["RICH_TEXT"] = "rich_text";
    FieldType["NUMBER"] = "number";
    FieldType["DATE"] = "date";
    FieldType["DATE_AND_TIME"] = "date_and_time";
    FieldType["CHECKBOX"] = "checkbox";
    FieldType["DROPDOWN"] = "dropdown";
    FieldType["MULTI_SELECT_DROPDOWN"] = "multi_select_dropdown";
    FieldType["USER"] = "user";
    FieldType["FILE"] = "file";
    FieldType["EMAIL"] = "email";
    FieldType["PHONE"] = "phone";
    FieldType["LOCATION"] = "location";
    FieldType["JSON"] = "json";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
var DefaultEntityFields;
(function (DefaultEntityFields) {
    DefaultEntityFields["ID"] = "id";
    DefaultEntityFields["CREATED_ON"] = "created_on";
    DefaultEntityFields["CREATED_BY"] = "created_by";
    DefaultEntityFields["UPDATED_ON"] = "updated_on";
    DefaultEntityFields["UPDATED_BY"] = "updated_by";
    DefaultEntityFields["IS_ARCHIVED"] = "is_archived";
})(DefaultEntityFields = exports.DefaultEntityFields || (exports.DefaultEntityFields = {}));
